import React from 'react'

const LabelText = ({ block, label, children, style }) => {
  return (
    <div
      style={{
        display: block ? 'block' : 'inline',
        marginBottom: 10,
        ...style
      }}
    >
      {label && <span style={{ color: '#666' }}>{label}：</span>}
      <span style={{ color: '#333' }}>{children}</span>
    </div>
  )
}

export default LabelText
